import { render, staticRenderFns } from "./PackageAndHistory.vue?vue&type=template&id=74462d5c&scoped=true"
import script from "./PackageAndHistory.vue?vue&type=script&lang=js"
export * from "./PackageAndHistory.vue?vue&type=script&lang=js"
import style0 from "./PackageAndHistory.vue?vue&type=style&index=0&id=74462d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74462d5c",
  null
  
)

export default component.exports